<template>
  <div class="additional-settings-wrapper">
    <h1>Additional Setting</h1>
    <div class="content-box">
      <div class="img-box">
        <img src="@/assets/imgs/description.svg">
      </div>
      <div class="content">
        <h5>Description</h5>
        <p v-if="contest.desc">{{contest.desc}}</p>
        <p v-else>Add desciption about the contest</p>
        <p>
          <button class="add-link" v-if="contest.desc" @click="addDesc = true">Edit</button>
          <button class="add-link" v-else @click="addDesc = true">Add</button>
        </p>
        <AddTextPopup @onClose="onClose" :payload="contest" :property="'desc'" :show="addDesc"></AddTextPopup>
      </div>
    </div>
    <div class="content-box">
      <div class="img-box">
        <img src="@/assets/imgs/join-code.svg">
      </div>
      <div class="content">
        <h5>Join Code</h5>
        <p v-if="contest.code">{{contest.code}}</p>
        <p v-else>Create a join code. It allow players to join the contest.</p>
        <p>
          <button class="add-link" v-if="contest.code" @click="createCode = true">Edit Code</button>
           <button class="add-link" v-else @click="createCode = true">Create</button>
        </p>
        <AddTextPopup @onClose="onCodeClose" :payload="contest" :property="'code'" :show="createCode"></AddTextPopup>
      </div>
    </div>
    <div class="content-box">
      <div class="img-box">
        <img src="@/assets/imgs/leader-board.svg">
      </div>
      <div class="content">
        <h5>Leaderboard</h5>
        <p>Players can view points table. By default it will be enabled.</p>
        <p>
          <el-switch
            v-model="contest.leaderBoard"
            :active-text="contest.leaderBoard ? 'DISABLE' : 'ENABLE'">
          </el-switch>
          <!-- <button class="add-link" v-if="contest.leaderBoard" @click="contest.leaderBoard = false">Disable</button>
          <button class="add-link" v-else @click="contest.leaderBoard = true">Enable</button> -->
        </p>
      </div>
    </div>
    <button class="confirm-btn" @click="saveSettings(contest)">Continue
    </button>
  </div>
</template>
<script>
import { DataState } from '@/state'
import AddTextPopup from '@/components/fantasyconsole/AddTextPopup'

export default {
  components: {
    AddTextPopup
  },
  props: {
    contest: {
      type: Object,
      defult: null
    },
    contestKey: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      ruleManager: null,
      state: DataState.newNotInit(),
      startDate: null,
      endDate: null,
      addDesc: false,
      createCode: false,
      featureContest: false
    }
  },

  mounted () {
  },

  methods: {
    saveSettings (contest) {
      this.$emit('saveSettings', contest)
    },
    onClose (payload, show) {
      this.addDesc = show
    },
    onCodeClose (payload, show) {
      this.createCode = show
    }
  }
}
</script>
